import React, { useState, useEffect, useMemo } from "react";
import { useAuth } from "../../context/ContextApi";
import { parseISO, formatDistance } from "date-fns";
import pt from "date-fns/locale/pt";

import bell from "../../assets/img/bell.svg";
import avatar from "../../assets/img/avatar.svg";

import { Badge } from "./styles";
import "./styles.scss";
import api from "../../config/api";
import io from "socket.io-client";
import CircleImage from "../Image/CircleImage";
require("dotenv").config();

export default function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { userToken, userId, userEstablishment } = useAuth();
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  useEffect(() => {
    userToken && loadNotifications(userToken);
  }, [userToken]);

  const hasUnread = useMemo(
    () => !!notifications.find((notification) => notification.reading === false),
    [notifications]
  );
  const setNotificationRead = async (_id) => {
    try {
      await api.put(
        "notifications-desactive/" + _id,
        {
          reading: true,
        },
        {
          headers: { Authorization: `Bearer ${userToken}` },
        }
      );
    } catch (e) {
      console.error(e);
    }
  };
  const setAllNotificationsRead = async () => {
    notifications.forEach(async (notification) => {
      await setNotificationRead(notification._id);
    });

    const readNotifications = notifications.map((notification) => ({
      ...notification,
      reading: true,
    }));
    setNotifications(readNotifications);
  };
  async function loadNotifications(tokenValue) {
    try {
      const response = await api.get("notifications", {
        headers: { Authorization: `Bearer ${tokenValue}` },
      });
      const data = response.data.map((notification) => ({
        ...notification,
        timeDistance: formatDistance(parseISO(notification.createdAt), new Date(), { addSuffix: true, locale: pt }),
      }));
      setNotifications(data);
    } catch (e) {
      console.error(e);
    }
  }
  async function deleteNotifications(tokenValue) {
    try {
      await api.delete(`notifications/${userId}`, {
        headers: { Authorization: `Bearer ${tokenValue}` },
      });
      loadNotifications();
    } catch (e) {
      console.error(e);
    }
  }
  async function handleNotificationClick(event, _id) {
    event.preventDefault();
    await setNotificationRead(_id);
    window.location.href = `/reservas/todas`;
  }

  useEffect(() => {
    const socket = io(process.env.REACT_APP_SOCKETIO_URL, { transports: ["websocket", "polling"] });
    socket.on("notificationEstablishment", (data) => {
      if (data?.establishment._id === userEstablishment) {
        console.log(data);
        setNotifications([data, ...notifications]);
      }
    });
    return () => {
      socket.disconnect();
    };
  }, [notifications, userEstablishment]);

  function NotificationItem(props) {
    return (
      <a
        href={`/reservas/todas`}
        onClick={(event) => handleNotificationClick(event, props._id)}
        className="notification-item mx-4 fz-14 text-prop-grey-light c-pointer d-flex align-items-center "
      >
        <div className="mb-5">
          <CircleImage
            url={props.avatar !== undefined ? (props.avatar !== "" ? props.avatar : avatar) : avatar}
            sizePx={"40px"}
            className={"c-pointer"}
          />
        </div>

        <div className="ms-2 d-flex flex-column c-pointer notification-item-content col-lg-10">
          <label className=" fz-16 ff-univanova-regular text-black fw-bold c-pointer">Nova notificação!</label>
          <label className=" fz-14 ff-univanova-regular text-black fw-600 c-pointer mb-2 mt-1 text-break ">
            {props.description}
          </label>
          <label className="d-block fz-12 ff-univanova-regular  c-pointer text-cl-auroMetal">{props.time}</label>
        </div>
        {!props.reading && <div className="notification-unread-symbol"></div>}
      </a>
    );
  }
  return (
    <>
      <Badge
        onClick={() => toggleSidebar()}
        type="button"
        className="btn btn-secondary  p-0 box-shadow-none"
        hasUnread={hasUnread}
      >
        <div className="bad">
          <img width={24} height={24} className="" src={bell} alt="" />
        </div>
      </Badge>
      {isSidebarOpen && (
        <>
          <div className="notifications-sidebar-backdrop" onClick={() => toggleSidebar()}></div>
          <ul className="notifications-sidebar ">
            <li className="notifications-sidebar-header d-flex mx-4 pt-4 pb-2 px-0">
              <label>Notificações</label>
              <svg
                className="close-notifications-sidebar-button"
                onClick={() => toggleSidebar()}
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
              >
                <path
                  id="Caminho_3043"
                  data-name="Caminho 3043"
                  d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z"
                  transform="translate(-5 -5)"
                  fill="#0c1c27"
                />
              </svg>
            </li>
            <div className="notification-items-container pb-4 default-scroll px-0 overflow-auto">
              {notifications.map((notification, index) => (
                <NotificationItem
                  key={index}
                  _id={notification._id}
                  user={notification.from.name}
                  time={notification.timeDistance}
                  avatar={notification.from?.avatar}
                  reading={notification.reading}
                  description={notification.description}
                />
              ))}
            </div>
            <li id="notifications-sidebar-footer" className="d-flex justify-content-end px-4">
              <button
                onClick={() => setAllNotificationsRead()}
                className="btn fz-14 br-6 button-transparent-primary border-auro-metal me-2"
              >
                Marcar todas como lidas
              </button>
              <button
                onClick={() => deleteNotifications()}
                className="btn fz-14 btn-cl-red text-white ff-univanova-medium  "
              >
                Limpar tudo
              </button>
            </li>
          </ul>
        </>
      )}
    </>
  );
}
